module.exports = __webpack_public_path__ + "static/img/ybj.58fdcd52.png";